import { Select } from "antd"
import React from "react"

const SelectDiscountType = ({ value, onChange,disabled, style={ height: "36px"} }) => {
  return (
    <Select
      placeholder="Chọn loại chiết khấu"
      title="Chọn loại chiết khấu"
      allowClear
      value={value}
      onChange={onChange}
      disabled = {disabled}
      style={style}
    >
      <Select.Option value="percent">Chiết khấu %</Select.Option>
      <Select.Option value="fixed">Chiết khấu số tiền</Select.Option>
    </Select>
  )
}

export default SelectDiscountType
